import React, {useEffect, useRef,useState } from "react"; 
import { Button, Modal } from 'react-bootstrap';
import {getSubjects} from "../../../../Services/Subjects/SubjectServices"
import  {getCategories,gameCreate} from "../../../../Services/gameServices" 
import 'bootstrap/dist/css/bootstrap.min.css';
import { toast } from 'react-toastify';

const CreateGame = ({ reRender,isShow,close }) => {  
  const handleShow = () => setShow(true);
  const handleClose = () => {setShow(false);close()};
  const [show, setShow] = useState(false);
  const [isLoading, setIsloading] = useState(false);
  const [subject, setSubject] = useState('');
  const [gameLevelId, setGameLevelId] = useState(''); 
  const [gameName, setGameName] = useState('');
  const [description, setDescription] = useState('');
  const [asset, setAsset] = useState(null);

  const [subjectError, setSubjectError] = useState(false);
  const [gameLevelIdError, setGameLevelIdError] = useState(false); 
  const [gameNameError, setGameNameError] = useState(false);
  const [descriptionError, setDescriptionError] = useState(false);
  const [assetError, setAssetError] = useState(null);
  const [subjects, setSubjects]           = useState([]); 
  const [categoryData, setCategoryData]  = useState([]);
  const checkFormValidation =()=>{ 
    if (!subject.trim() || !gameLevelId.trim() || !gameName.trim() || !description.trim() || !asset) {
      setSubjectError(!subject.trim());
      setGameLevelIdError(!gameLevelId.trim())
      setGameNameError(!gameName.trim()) 
      setDescriptionError(!description.trim()) 
      setAssetError(!asset) 
      return true;
    }   
    return false;
  }

  const handleSubmit = async (e) => {  
     if(checkFormValidation()){
      return ;
     } 
     const formData = new FormData();
     formData.append('subjectid',subject);
     formData.append('game_level_id',gameLevelId);
     formData.append('name', gameName.trim());
     formData.append('description', description.trim());
     formData.append('game', asset);
        setIsloading(true)
        gameCreate(formData).then((Response)=>{ 
         setIsloading(false)
          if(Response.status){    
            toast.success(Response.message) 
            reRender()
            handleClose()
          }else{
            toast.error(Response.errorMessage)
          } 
        }) 
   };

  useEffect(() => { 
    getSubjects().then((data)=>{
        if(data.status){
          setSubjects(data.data) 
        }
      })
    setShow(isShow)
  }, []); 

  const retriveCategories=(id)=>{
      getCategories(id)
      .then((data) => { 
          setCategoryData(data?.status ? data.data : []);
      })
      .catch((error) => {
          console.error("Error fetching categories:", error);
          setCategoryData([]);
      });
      }

  const callCategories = (e) => {
    setSubjectError(false)
     const value = e.target.value;
     setSubject(value); 
     setGameLevelId(''); 
     if (value !== "") {
       retriveCategories(value)
     } else {
         setCategoryData([]);
     }
  };
const MAX_FILE_SIZE = 500 * 1024 * 1024; 

const handleFileChange = (e) => {
  const selectedFile = e.target.files[0];

  if (!selectedFile) {
    setAssetError("Please provide a file.");
    setAsset(null);
    return;
  }

  if (!selectedFile.name.endsWith(".zip")) {
    toast.error("Please provide a .zip format file only.");
    setAsset(null);
    e.target.value = null;
    return;
  }

  if (selectedFile.size > MAX_FILE_SIZE) {
    toast.error("File size should not exceed 500MB.");
    setAsset(null);
    e.target.value = null;
    return;
  }

  setAssetError("");
  setAsset(selectedFile);
};

  return ( 
    <Modal show={show} onHide={handleClose} dialogClassName="modal-xl">
        <Modal.Header closeButton>
        <h5 className="modal-title">Add Game</h5>
        </Modal.Header>
        <Modal.Body>
        <form className="row g-3 needs-validation" >
              <div className="col-6 px-3">
                <label for="NewGameSubject" className="form-label required">Subject</label>
                <select
                  className="form-control" 
                  name="subjectid"
                  onChange={callCategories} 
                >
                  <option  value="">--Select Subject--</option>
                  {subjects.map((data)=>{
                  return (<>
                   <option value={data.id}>{data.name}</option>
                  </>)
                })}
                </select>
                <div className="new-game-subject invalid-feedback"  style={{ display: subjectError ? 'block' : 'none' }}>Please select subject.</div>
              </div>
              <div className="col-6 px-3">
                <label for="NewGameCategory" className="form-label required">Category</label>
                <select 
                  className="form-control" 
                  name="categoryid"
                  onChange={(e)=>{setGameLevelId(e.target.value);setGameLevelIdError(false);}}
                  disabled={!subject}
                >
                  <option value="">--Select Category--</option>
                  {categoryData.map((data)=>{
                    return (<>
                      <option value={data.id}>{data.name}</option>
                    </>)
                  })}
                </select>
                <div className="new-game-category invalid-feedback"  style={{ display: gameLevelIdError ? 'block' : 'none' }}>Please select category.</div>
              </div>
              <div className="col-6 px-3">
                <label for="NewGameName" className="form-label required">Game Name</label>
                <input type="text" className="form-control"  maxLength="70" onChange={(e)=>{setGameNameError(false);setGameName(e.target.value);}}   placeholder="Enter Game Name" />
                <div className="new-game-name invalid-feedback"  style={{ display: gameNameError ? 'block' : 'none' }}>Please provide game name.</div>
              </div>
              <div className="col-6 px-3">
                <label for="NewGameDescription" className="form-label required">Description</label>
                <input type="text" className="form-control" onChange={(e)=>{setDescriptionError(false);setDescription(e.target.value);}}  placeholder="Enter Description" />
                <div className="new-game-description invalid-feedback" style={{ display: descriptionError ? 'block' : 'none' }}>Please provide description.</div>
              </div>  
              <div className="col-6 px-3">
                <label for="NewGameFile" className="form-label required">Select Game File</label>
                <input type="file" onChange={handleFileChange} className="form-control" accept="zip,application/octet-stream,application/zip,application/x-zip,application/x-zip-compressed" />
                <div className="new-game-file invalid-feedback"  style={{ display: assetError ? 'block' : 'none' }}>Please provide file.</div>
                <div className="new-game-file-validate invalid-feedback">Please provide .zip format file only.</div>
              </div>   
            </form>          
        </Modal.Body>
        <Modal.Footer>
                  <button
                  type="button"
                  id="closesubject"
                  disabled={isLoading?true:false}
                  className="btn btn-secondary" 
                  onClick={()=>handleClose()}
                >
                  Close
                </button>
                <button
                  id="createsubject"
                  type="button"
                  className="btn btn-primary"
                  style={{ display: !isLoading ? 'block' : 'none' }}
                  disabled={isLoading?true:false}
                  onClick={handleSubmit}
                >
                  Save
                </button>
                <button  style={{ display: isLoading ? 'block' : 'none' }} className="btn btn-primary" type="button" disabled>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  &nbsp;Saving...
                </button>
              </Modal.Footer>
      </Modal>
       
  );
};

export default CreateGame;
